import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('STACK_MAP', {
  REQUEST: null,
  SUCCESS: null,
  FAILURE: null,
  CLOSE: null
});
